// src/components/IntroTab.js
import '../App.css';
import React, { useState, useEffect } from 'react';

const IntroTab = ({ data, onChange }) => {
  const [bookTitle, setBookTitle] = useState(data.bookTitle || '');
  const [openingHook, setOpeningHook] = useState(data.openingHook || '');

  useEffect(() => {
    // Update the local state when the external data changes
    setBookTitle(data.bookTitle || '');
    setOpeningHook(data.openingHook || '');
  }, [data.bookTitle, data.openingHook]);

  const handleTitleChange = (e) => {
    const updatedBookTitle = e.target.value;
    setBookTitle(updatedBookTitle);
    onChange({ bookTitle: updatedBookTitle, openingHook });
  };

  const handleOpeningHookChange = (e) => {
    const updatedOpeningHook = e.target.value;
    setOpeningHook(updatedOpeningHook);
    onChange({ bookTitle, openingHook: updatedOpeningHook });
  };

  return (
    <div className='tab-styling'>
      <p className='synopsis-paragraph'>If you are a writer like me you dread the synopsis. So I made this tool to hold my hand. In order for this wizard to work, you need to know your story. Are you ready? Let's get started!</p>
      <div className="nice-form-group">
      <label>Book Title:</label>
      <input type="text" value={bookTitle} onChange={handleTitleChange} style={{width: "95%"}} />
      </div>
      <div className="nice-form-group">
      <label>Opening Hook:</label>
      <textarea value={openingHook} onChange={handleOpeningHookChange} />
      </div>
     <p className='synopsis-paragraph'>If you want to have an opening sentence(s) (1-2 is recommended), here is your chance. Perhaps you need to set the tone or drops hints this is a futuristic fantasy with comedic elements. Use your writing voice and grab the reader with this first sentence!</p>
    </div>
  );
};

export default IntroTab;
